import { render, staticRenderFns } from "./SupplierBrandSelect.vue?vue&type=template&id=7b1b2777&scoped=true&"
import script from "./SupplierBrandSelect.vue?vue&type=script&lang=js&"
export * from "./SupplierBrandSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b1b2777",
  null
  
)

export default component.exports